// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * Models for news operations
 */
import type * as Schemas from '../schemas.js';





/**
 * Response for get
 * 
 * @public
 */
export type GetResponse = Schemas.Get2NewsIdResponse;
/**
 * Response for search
 * 
 * @public
 */
export type SearchResponse = Schemas.Get2NewsSearchResponse;